<!-- eslint-disable -->
<template lang="pug">
    .box
        .box-body
            .box-body__title {{ $i18n.t('olympiads.olympiads_layout_olympiads') }}
            .box-body__create-battle(v-if="isShowButtonCreateOlymp")
                cs-button(
                    color="blue"
                    pattern="primary-outline"
                    @click=`$router.push({name: 'olympiads:create'})`
                    narrow
                )
                    svg-icon(name="plus" size="large" slot="icon")
                    | {{ $i18n.t('olympiads.olympiads_create_createOlympiad') }}
            cs-loader(v-if="isLoading")
            .box-body__olympiads(v-else-if="olympiads.length")
                olympiad(
                    v-for="olympiad in olympiads",
                    :olympiad="olympiad",
                    :key="olympiad.id",
                    @click.native="showOlympiad($event, olympiad)"
                )
            div.box-body__olympiads_empty(v-else) {{ $i18n.t('olympiads.olympiads_list_noAvailable') }}
</template>

<script>
    /*eslint-disable*/
    import OlympiadApi from '../../api/olympiad';
    import { mapState } from 'vuex';
    import Olympiad from './Olympiad.vue';
    import _ from 'lodash';

    export default {
        data() {
            return {
                olympiads: [],
                isLoading: true,
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                course: state => state.trainer.course,
            }),
            isShowButtonCreateOlymp() {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                let form = {
                    'order_by[]': ['date:desc', 'status:desc'],
                };
                if(this.user.type === 'student') {
                    form.course_type = _.kebabCase(this.course);
                }
                return OlympiadApi.list(form)
                    .then(data => {
                        this.olympiads = data || [];
                        this.isLoading = false;
                    })
                    .catch(err => {
                        this.$toasted.error(this.$root.$t('errors.getting_olympiadList'));
                        this.isLoading = false;
                    });
            },
            showOlympiad(event, olympiad) {
                if (event.target.tagName === 'A') {
                    return;
                }
                if (olympiad.status !== 'archived') {
                    if (
                        (this.user.type === 'student' || this.user.type === 'olympiads-student') &&
                        !this.user.registeredOlympiads.find(element => element.id === olympiad.id)
                    ) {
                        if (!olympiad.isRegistrationAllowed) {
                            this.$router.push({ name: 'olympiads:show', params: { id: olympiad.id } });
                        } else {
                            this.$router.push({ name: 'olympiads:register', params: { id: olympiad.id } });
                        }
                    } else {
                        this.$router.push({ name: 'olympiads:show', params: { id: olympiad.id } });
                    }
                } else {
                    this.$router.push({ name: 'olympiads:results', params: { id: olympiad.id } });
                }
            },
        },
        components: {
            Olympiad,
        },
    };
</script>

<style scoped lang="scss">
    .box {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border-radius: 0;
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        @include media($sm) {
            padding: 30px;
            border-radius: 40px;
        }
    }
    .box-body {
        width: 100%;
        height: 100%;
    }
    .box-body__title {
        white-space: nowrap;
        text-align: center;
        font-family: 'Appetite';
        font-size: 42px;
        line-height: 42px;
        color: #2187ff;
        margin-bottom: 15px;
        @media screen and (max-width: 600px) {
            font-size: 36px;
            white-space: normal;
        }
    }
    .box-body__create-battle {
        margin: 0 auto;
        max-width: 198px;
    }
    .battle-create-button {
        padding: 15px 30px;
        background: #2187ff;
        border-radius: 40px;
        text-align: center;
        font-family: 'Rubik';
        font-size: 16px;
        line-height: 19px;
        color: #ffffff;
        &:hover {
            background: #0070f4;
        }
    }
    .box-body__olympiads {
        margin-top: 30px;
        &:after {
            display: block;
        }
        @include media($md) {
            &:after {
                content: '';
                display: table;
                clear: both;
            }
        }
    }
    .box-body__olympiads_empty {
        font-family: Appetite;
        font-style: normal;
        font-weight: normal;
        text-align: center;
        color: #2187ff;
        font-size: 32px;
        line-height: 32px;
        margin: 1rem 0 5rem 0;
        @include media($sm) {
            font-size: 42px;
            line-height: 42px;
            margin: 6rem 0;
        }
    }
</style>
